// extracted by mini-css-extract-plugin
export default {"Container":"Chat_Container__LvKbe","ChannelListWrap":"Chat_ChannelListWrap__d9vDO","ConversationWrap":"Chat_ConversationWrap__pGu1A"};